import { ListBulletsIcon, RowsIcon } from '@phosphor-icons/react'
import { TFunction } from 'i18next'

export type TableViewValues = 'category' | 'detail'

export const getTableViews = (tTenantListPage: TFunction<'pages', 'assets.assetDetails.valuation.valuationTenantListPage'>) => [
    { label: tTenantListPage('viewSwitch.summary'), value: 'category', leftIcon: <RowsIcon /> },
    { label: tTenantListPage('viewSwitch.tenantDetails'), value: 'detail', leftIcon: <ListBulletsIcon /> },
]
